import React from 'react';

function BioCard({ name, alias, role, interests, image }) {
  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden w-full max-w-xs text-center">
      <img src={image} alt={name} className="w-full h-64 object-cover" />
      <div className="p-4 space-y-2">
        <h2 className="text-xl font-bold text-gray-800">{name} <span className="text-sm text-gray-500">(@{alias})</span></h2>
        <p className="text-indigo-600 font-semibold">{role}</p>
        <p className="text-sm text-gray-600">{interests}</p>
      </div>
    </div>
  );
}

export default BioCard;
